module.exports = __webpack_public_path__ + "img/Vue.js-logo.9a45fc76.svg";